import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { getAvatarInitials } from '../utils/getAvatarInitials';
import { Avatar } from './RoleAvatar.styles';

const RoleAvatar = ({ name, color }) => {
  const [agencyInitials] = useState(getAvatarInitials(name));
  const bgColor = color || '#00c384';

  return <Avatar bgColor={bgColor}>{agencyInitials}</Avatar>;
};

RoleAvatar.propTypes = {
  name: PropTypes.string.isRequired,
};

export default RoleAvatar;
